var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "energy",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "39.65 21.17 30.17 21.17 27.86 21.17 33.33 0.95 16.93 21.17 16.9 21.17 10.58 28.75 22.37 28.75 16.9 48.97 33.3 28.75 33.33 28.75 39.65 21.17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnergy);
export default __webpack_public_path__ + "static/media/icon_energy.9a5f4c2f840c113476fe6404cfa682e7.svg";
export { ForwardRef as ReactComponent };